// Import base components
import { httpV2 } from "../http.js";

export const sendAirBnBMessage = (ota_id, msg) =>
  httpV2.post(`/airbnb/message/${ota_id}`, { message: msg });

export const sendAirBnBImageMessage = (
  ota_id,
  upload_url,
  mime_type,
  message,
) => {
  return httpV2.post(`/airbnb/message/${ota_id}/image`, {
    upload_url,
    mime_type,
    message,
  });
};

export const getAirBnBThreads = (thread_ids) => {
  return httpV2.post(`/airbnb/threads`, { thread_ids });
};

export const getAirbnbAccounts = () => {
  return httpV2.get(`/airbnb/accounts`);
};

export const disconnectAirbnbAccount = (id) => {
  return httpV2.delete(`/airbnb/accounts/${id}`);
};

export const confirmReservation = (confirmation_id, reason) => {
  return httpV2.put(`/airbnb/reservation/${confirmation_id}/accept`, {
    reason,
  });
};

export const denyReservation = (confirmation_id, reason, response) => {
  return httpV2.put(`/airbnb/reservation/${confirmation_id}/deny`, {
    reason,
    response,
  });
};

export const airbnbUploadFile = async (thread_id, file) => {
  let resp = await httpV2.post(`/airbnb/upload_url`, {
    thread_id: thread_id,
    mime_type: file.type,
  });

  if (!!resp?.error) {
    return [null, null, resp.error];
  }

  let headers = new Headers();
  headers.append("Content-Type", file.type);

  let options = {
    method: "PUT",
    headers: headers,
    body: file,
    redirect: "follow",
  };

  console.log("Upload URL:", resp.data);

  let uploadUrl = resp.data?.url;
  let response = await fetch(uploadUrl, options)
    .then((uploadResponse) => {
      return { error: null };
    })
    .catch((error) => {
      return { error: error };
    });

  console.log("RESPONDED:", response);

  if (!!response.error) {
    return [null, null, response.error];
  }

  let realUrl = uploadUrl.split("?")[0];
  console.log(realUrl);
  return [realUrl, file.type, null];
};
